<div class="drawer-wrapper" fxLayout="column">
  <div class="title">Zone Editor tool</div>
  <div class="tab-list">
    <mat-tab-group [selectedIndex]="selectedTab" mat-align-tabs="start">
      <mat-tab label="Zones">
        <ng-template matTabContent>
          Zones list works!
        </ng-template>
      </mat-tab>
      <mat-tab label="Categories">
        <ng-template matTabContent>
          <app-category-content></app-category-content>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
